// div搭建表格
import React, { useEffect, useRef, useState } from 'react';

import SvgIcon from '@/pages/home/components/SvgIcon';

import TranslateSelect from '@/pages/opinion/components/SelectComponents/TranslateSelect';
import AddCompare from './Components/AddCompare';
import KeyMetricsRow from './Components/KeyMetricsRow';
import ChannelRow from './Components/ChannelRow';
import TopicRow from './Components/TopicRow';
import ReleaseRow from './Components/ReleaseRow';
import HeaderRow from './Components/HeaderRow';
import useGameCompetitor from '../../hooks/useGameCompetitor';
import CardCommon from '@/pages/opinion/components/CardCommon';
import './index.scss';
import useLanguage from '@/pages/opinion/hooks/useLanguage';
import UserGuideCompetitor from '@op/components/UserGuide/competitor';

// 大模块数据的左侧固定数据
const TypeList = [
  {
    title: 'Key Metrics',
    type: 1,
  },
  {
    title: 'Channel / Region / Market / Language Distribution (Top 3)',
    type: 2,
  },
  {
    title: 'Topic / Keywords',
    type: 3,
  },
  {
    title: 'Release Days',
    type: 4,
  },
];

export default function ComparisonCard({
  filter,
  gameInfo,
  translateTopicFunc,
}: any) {
  const [visible, setVisible] = useState(false);
  const [isShadow, setShadow] = useState(false);
  const { formatMessage } = useLanguage();
  const headerDom = useRef<HTMLDivElement>(null);
  const timer = useRef<any>(null);
  const onSrcoll = (e: any) => {
    // e.persist();
    // sticky-text 滚动时候表格第二列阴影  注意分为头部和内容
    const { scrollLeft } = e.target;
    // setSrcollDef(scrollLeft);
    let flag = true;
    // eslint-disable-next-line prefer-const
    // 延时器可以写在if里面，也可以写在外面，如果写在外面，必须清理延时器，否则会创建多个延时器，导致flag很快为true，就一直输出1；如果写在里面，想要执行定时器，必须通过if语句，确保了定时器的安全
    if (timer.current) {
      clearTimeout(timer.current);
    }

    if (flag) {
      flag = false;
      if (scrollLeft !== 0) {
        setShadow(true);
        if (headerDom.current) {
          headerDom.current.scrollLeft = scrollLeft;
        }
      } else {
        setShadow(false);
        if (headerDom.current) {
          headerDom.current.scrollLeft = 0;
        }
      }
    }
    timer.current = setTimeout(() => {
      flag = true;
    }, 2000);
  };

  useEffect(() => {
    return () => {
      if (timer.current) {
        clearTimeout(timer.current);
      }
    };
  }, []);

  const {
    mainGame,
    competitorGame,
    originalGameList,
    originalGameAndMainGame,
    sortCompetitorGame,
    deleteCompetitorGame,
    changeCompetitorGame,
    loading,
    isCache,
  } = useGameCompetitor({ gameInfo, filter });

  return (
    <>
      <CardCommon
        loading={loading}
        loadingHeight={450}
        title={formatMessage({ id: 'Comparison Overview' })}
        className="dbo-comparison-card"
      >
        <>
          <UserGuideCompetitor></UserGuideCompetitor>
          <div className="comparison-table">
            <div className="comparison-table-context">
              {/* 表头 */}
              <div
                className="comparison-table-hd comparison-table-hd--fixed"
                ref={headerDom}
              >
                <div className="comparison-table-box">
                  <div className="comparison-table-hd-flex">
                    <div
                      className="header-first first-col"
                      onClick={() => setVisible(true)}
                    >
                      <SvgIcon
                        type="add-border"
                        className="header-first-icon"
                      />
                      {formatMessage({ id: 'Add & Sort Games' })}
                    </div>
                    {originalGameAndMainGame.map((e: any, i: any) => {
                      return (
                        <div
                          key={e.edition_unified_id}
                          className={`comparison-header-item ${
                            isShadow && i == 0 ? 'sticky-text' : ''
                          }`}
                        >
                          <HeaderRow
                            isShadow={isShadow}
                            detail={e}
                            showSelect={i !== 0 && e.entity_type === 'mobile'}
                            gameInfo={gameInfo}
                            // 因为后续会切掉了第一个主游戏，所以这里删除的数据的下标信息向前移动了一位
                            deleteCompetitorGame={() =>
                              deleteCompetitorGame(i - 1)
                            }
                            sortCompetitorGames={() =>
                              sortCompetitorGame(i - 1)
                            }
                            changeCompetitorGame={(changeId: string) => {
                              changeCompetitorGame(
                                {
                                  ...e,
                                  selected_edition_unified_id: changeId,
                                },
                                i - 1,
                              );
                            }}
                          />
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
              {/* 表分类 */}
              <div className="comparison-table-bd" onScroll={onSrcoll}>
                <div className="comparison-table-box">
                  {TypeList.map((e: any, i: any) => {
                    return (
                      <Context
                        key={i}
                        data={e}
                        translateTopicFunc={translateTopicFunc}
                        isCache={isCache}
                        isShadow={isShadow}
                        games={competitorGame}
                        filter={filter}
                      />
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </>
      </CardCommon>
      {visible && (
        <AddCompare
          visible={visible}
          mainGame={mainGame}
          selected={originalGameList}
          close={() => setVisible(false)}
          confirm={(targetList: any[]) => {
            changeCompetitorGame(targetList);
          }}
        />
      )}
    </>
  );
}

const langOptions = [
  {
    // value: 'Original Language',
    text: 'Original Language',
    value: 'origin',
  },
  {
    value: 'en',
    text: 'English',
  },
  {
    text: 'Chinese',
    value: 'zh',
  },
];
// 每一个模块
const Context = (props: any) => {
  const { data, ...params } = props;
  const [show, setShow] = useState(true); // 默认展开
  const [lang, setLang] = useState('origin');
  const { formatOptionsMessage, formatMessage } = useLanguage();

  function getRenderList() {
    if (data.type === 1) return <KeyMetricsRow {...params} />;
    if (data.type === 2) return <ChannelRow {...params} />;
    if (data.type === 3) return <TopicRow lang={lang} {...params} />;
    if (data.type === 4) return <ReleaseRow {...params} />;

    return null;
  }

  return (
    <div className="table-context">
      <div className="table-context-title" onClick={() => setShow(!show)}>
        <SvgIcon
          type="fill-icon-arrow"
          className={show ? 'table-context-icon' : ' show-icon'}
        />
        <span className="context-text">
          {formatMessage({ id: data.title })}
        </span>
        {data.type == 3 && (
          <TranslateSelect
            isSingle={true}
            lang={lang}
            langOptions={formatOptionsMessage(langOptions)}
            getChange={(e: any) => setLang(e)}
          />
        )}
      </div>
      <div style={{ background: '#fff' }} className={show ? '' : 'context-box'}>
        {getRenderList()}
      </div>
    </div>
  );
};
